module.exports = __webpack_public_path__ + "static/testimonial_person_3-8e3d2e2bc20a4644368744a8b604c603.jpg";